import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { DocumentoModel } from '../models/documento.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResposeInfoModel } from '../models/response-info.model';


@Injectable({
  providedIn: 'root'
})
export class DocumentoService extends BaseService<DocumentoModel>{

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Documento' ;
    this.urlBase = `${environment.baseApi}${environment.endPoints.documento.base_documento}`;
   }

   saveDocumento(idVehiculo: number, fechaVencimiento: string, idTipoDocumento, files: File[]): Observable<DocumentoModel> {
    const formData: FormData = new FormData();
    files.forEach((file) => {
      formData.append('imagen', file);
    });
    return this.httpClient.post<DocumentoModel>(`${this.urlBase}?idVehiculo=${idVehiculo}&fechaVencimiento=${fechaVencimiento}&idTipoDocumento=${idTipoDocumento}`, formData);
   }

   findByVehiculo(id: number): Observable<DocumentoModel[]> {
    return this.httpClient.get<DocumentoModel[]>(`${this.urlBase}${environment.endPoints.documento.vehiculo}/${id}`);
   }

   findByVehiculoMe(id: number): Observable<DocumentoModel[]> {
    return this.httpClient.get<DocumentoModel[]>(`${this.urlBase}${environment.endPoints.documento.vehiculo}${environment.endPoints.documento.me}/${id}`);
   }

   findByNombre() {

   }

   findMe() {

   }

   aprobar(id: number): Observable<ResposeInfoModel> {
    return this.httpClient.put<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.documento.aprobado}/${id}`, '');
   }

   denegar(id: number): Observable<ResposeInfoModel> {
    return this.httpClient.put<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.documento.denegado}/${id}`, '');
   }

   getImagenesDocumentos(idImagen: number): Observable<Blob> {
     return this.httpClient.get<Blob>(`${this.urlBase}${environment.endPoints.documento.imagenes}/${idImagen}`, { responseType: 'Blob'  as 'json'});
   }
}
